import { ArticleParagraph1 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { Link } from 'shared/components/Link';
import { NewbuildingInfo } from 'shared/components/NewbuildingInfo';
import { selectNewBuildingInfo } from 'shared/selectors/houseInfo';

export const NewbuildingInfoContainer = () => {
  const newbuildingInfo = useSelector(selectNewBuildingInfo);

  /* istanbul ignore next */
  if (!newbuildingInfo) {
    return null;
  }

  const { name, fullUrl, house } = newbuildingInfo;
  const newbuildingName = `ЖК «${name}»`;

  return (
    <ArticleParagraph1 as="div">
      <NewbuildingInfo
        name={fullUrl ? <Link href={fullUrl}>{newbuildingName}</Link> : /* istanbul ignore next */ newbuildingName}
        details={house?.name}
      />
    </ArticleParagraph1>
  );
};
